// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__Znn-X","pagination__button":"Pagination_pagination__button__apowu","pagination__buttonActive":"Pagination_pagination__buttonActive__ARs8B"};